function ServiceCard({ service, onLearnMore }) {
  return (
    <article className="rounded-3xl border border-brand-petal bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-bloom">
      <div className="mb-4 flex items-start justify-between gap-4">
        <h2 className="text-3xl leading-tight text-brand-text">{service.title}</h2>
        <button
          type="button"
          onClick={() => onLearnMore(service)}
          className="rounded-full border border-brand-primary/35 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-primary transition hover:bg-brand-mist"
        >
          Learn More
        </button>
      </div>
      <p className="text-sm leading-7 text-brand-text/80">{service.summary}</p>
      <p className="mt-4 text-lg font-semibold text-brand-deep">{service.price}</p>
    </article>
  );
}

export default ServiceCard;